import React from "react";
import { withPreloadedJSON } from "@wss/hypernova";
import { createRoot } from "@wss/react";
import { initSentry } from "@wss/error-tracking/sentry";
import { ErrorBoundary, logErrorBoundaryToSentry, PageFallback } from "@wss/error-tracking/error-boundary";
import App from "~/App";
import EmbeddedVideo, { EmbeddedVideoProps } from "./EmbeddedVideo";

/** Enable hot reloading */
module.hot?.accept();
initSentry("EmbeddedVideo");
function EmbeddedVideoWithErrorBoundary(props: Readonly<EmbeddedVideoProps>): JSX.Element {
  return <ErrorBoundary fallback={<PageFallback />} onError={logErrorBoundaryToSentry} data-sentry-element="ErrorBoundary" data-sentry-component="EmbeddedVideoWithErrorBoundary" data-sentry-source-file="index.client.tsx">
      <EmbeddedVideo {...props} data-sentry-element="EmbeddedVideo" data-sentry-source-file="index.client.tsx" />
    </ErrorBoundary>;
}
const EmbeddedVideoWithData = withPreloadedJSON(EmbeddedVideoWithErrorBoundary, "EmbeddedVideo");
const root = createRoot(document.querySelector("#root"));
root.render(<App>
    <EmbeddedVideoWithData />
  </App>);